import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#0b1e3f] text-slate-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-full bg-[#16a3a8] flex items-center justify-center text-white">
                <Sparkles className="w-5 h-5" />
              </div>
              <div className="text-lg font-extrabold text-white">
                topastrologer<span className="text-[#16a3a8]">inindia</span>.com
              </div>
            </Link>
            <p className="text-sm text-slate-400 mt-4 max-w-md leading-relaxed">
              India's most trusted ranking of online astrologers — covering Vedic, KP, Nadi,
              Tarot and Vastu. We help seekers find authentic guidance from verified experts.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-3 uppercase tracking-wider">Explore</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><a href="#astrologers" className="hover:text-white">Top Astrologers</a></li>
              <li><a href="#articles" className="hover:text-white">Articles</a></li>
              <li><a href="#reviews" className="hover:text-white">Reviews</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-3 uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/terms" className="hover:text-white">Terms of Use</Link></li>
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><Link to="/admin/login" className="hover:text-white">Admin</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-700 text-xs text-slate-500 flex flex-col md:flex-row justify-between gap-3">
          <div>Copyright © 2025 topastrologerinindia.com — All rights reserved.</div>
          <div>For entertainment &amp; guidance purposes. Astrology is not a substitute for medical, legal or financial advice.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
